import { Controller } from "@hotwired/stimulus"
import { shuffleClaims } from "../claim_shuffle.mjs"

export default class extends Controller {
  static targets = ["claim", "toggle", "label"]
  static values = { pause: String, resume: String }

  connect() {
    this.current = 0
    this.paused = false
    this.order = []
    this.motion = window.matchMedia("(prefers-reduced-motion: reduce)")
    this.refresh = this.refresh.bind(this)
    this.cache = this.cache.bind(this)
    this.motion.addEventListener("change", this.refresh)
    document.addEventListener("visibilitychange", this.refresh)
    document.addEventListener("turbo:before-cache", this.cache)
    this.show(0)
    this.refresh()
  }

  disconnect() {
    this.stop()
    this.motion.removeEventListener("change", this.refresh)
    document.removeEventListener("visibilitychange", this.refresh)
    document.removeEventListener("turbo:before-cache", this.cache)
  }

  toggle() {
    this.paused = !this.paused
    this.refresh()
  }

  refresh() {
    this.stop()
    this.toggleTarget.hidden = this.motion.matches || this.claimTargets.length < 2
    this.labelTarget.textContent = this.paused ? this.resumeValue : this.pauseValue
    this.toggleTarget.setAttribute("aria-pressed", String(this.paused))
    if (this.motion.matches) {
      this.show(0)
      this.order = []
      return
    }
    if (!this.paused && !document.hidden && this.claimTargets.length > 1) {
      this.timer = window.setTimeout(() => {
        if (!this.order.length) this.order = shuffleClaims(this.claimTargets.length, this.current)
        this.show(this.order.shift())
        this.refresh()
      }, 4800)
    }
  }

  show(index) {
    this.current = index
    this.claimTargets.forEach((claim, position) => claim.classList.toggle("is-active", position === index))
  }

  stop() {
    window.clearTimeout(this.timer)
    this.timer = null
  }

  cache() {
    this.stop()
    this.show(0)
    this.toggleTarget.hidden = true
  }
}
